import { PropType } from 'vue';
import { Vue, Options } from 'vue-class-component';
import { BuildingDTO, EntrancePlantDetailDTO } from '@/../client-generator/generated-clients/plants';
import { SET_APP_LOADING } from '@/core/store/action-types';
import { mapState } from 'vuex';
import plantsClient from '@/core/services/plants';

@Options({
  name: 'DialogCreateBackbone',
  props: {
    isVisible: {
      type: Boolean,
      required: true,
    },
    building: {
      type: Object as PropType<BuildingDTO>,
      required: true,
    },
  },
  computed: {
    ...mapState(['currentEntrancePlant']),
  },
  watch: {
    isVisible: function (newValue) {
      this.isDialogVisible = newValue;
    },
  },
  emits: ['hide-dialog', 'update-list'],
})
export default class DialogCreateBackbone extends Vue {
  currentEntrancePlant!: EntrancePlantDetailDTO;
  isVisible!: boolean;
  building!: BuildingDTO;
  isDialogVisible = false;

  get dialogTitle() {
    return this.$t('AppResourceEP.CreateBackbone');
  }

  get dialogMessage() {
    return this.$t('entrancePlant.createBackboneMessage');
  }

  mounted() {
    this.isDialogVisible = this.isVisible;
  }

  handleHideDialog() {
    this.isDialogVisible = false;
  }

  doHideDialog() {
    this.$emit('hide-dialog');
  }

  async doConfirm() {
    console.log('Building ID:', this.building.buildingId);
    const createdBackboneIds = await this.saveBackbone();
    this.$emit('update-list');
    this.handleHideDialog();
    //decidere se aprire edit del riser dopo creazione o no (piu facile no), aggiungere le varie stringhe)
  }

  async saveBackbone(): Promise<string[]> {
    if (this.currentEntrancePlant.desktopId === undefined) return [];
    this.$store.dispatch(SET_APP_LOADING, true);
    try {
     
      const createdBackbone = await plantsClient.backbone(this.currentEntrancePlant.desktopId, this.building.buildingId);
      this.$toast.add({
        severity: 'success',
        summary: this.$t('AppResourceEP.BackboneCreated'),
        closable: false,
        life: 3000,
      });
      return [createdBackbone.id ?? ''];
    } catch (error) {
      console.log(error);
      setTimeout(() => {
        this.$toast.add({
          severity: 'error',
          summary: this.$t('AppResource.Error'),
          closable: false,
          life: 3000,
        });
      }, 1500);
      return [];
    } finally {
      this.$store.dispatch(SET_APP_LOADING, false);
    }
  }
}
